<template>
  <div class="main">

      <transition name="slide-left">
        <div v-if="!counterDone" class="counter-wrapper">
          <div class="counter-content">
            <number
              ref="number1"
              :from="0"
              :to="100"
              :format="theFormat"
              :duration="3"
              :delay="0" 
              @complete = "completed" 
              easing="Power1.easeOut"/>%
          </div>
        </div>
      </transition>

      <transition name="slide-left">
        <div v-if="counterDone" class="tutorial-content-wrapper">
          <h3>What is a Safety Management System? <TextToSpeechSimple :inputText="textOneSpeech"></TextToSpeechSimple></h3>
          <!-- <p>{{interactionNeeded ? 'This is an interactive page' : 'This is a static page'}}</p> -->
          <!-- <button class="button is-primary" @click="sendData">{{hasInteracted ? 'Good job' : 'Click to interact'}}</button> -->
          <h4>{{textOne}}</h4>

          <img class="hero-pic" src="../assets/tour-checks.jpg" alt="What is an SMS">

          


          <div class="bottom-spacer"></div>

        </div>

      </transition>


  </div>
</template>


<script>

import TextToSpeechSimple from '../components/TextToSpeechSimple.vue';

export default {

  components: {
      TextToSpeechSimple,
  },

  props: [
      'interactionNeeded',
  ],

  computed: {

  },

  data() {
    return {
      counterDone: false,
      returnValue: '',
      hasInteracted: false,
      textOne: 'A Safety Management System (or SMS for short) is a set of rules and checklists that helps ensure you, your boat and your crew are always safe at work.',
      textOneSpeech: 'A Safety Management System (or SMS for short), is a set of rules and checklists that helps ensure, you, your boat, and your crew, are always safe at work.',
      // textOneSpeech: 'A Safety Management System (or SMS for short)',
    }
  },

  methods: {

    goBack: function() {
      console.log('Router',this.$router);
      this.$router.go(-1);
    },

    sendData: function() {
      let self = this;
      self.hasInteracted = true;
      let result = {
        hasInteracted: self.hasInteracted,
        // returnValue: self.returnValue
      }
      this.$emit('sendData', result)
    },

    theFormat(number) {
      return number.toFixed(0);
    },
    completed() {
      console.log('Animation ends!');
      this.counterDone = true;
    },
    playAnimation() {
      this.$refs.number1.play()
    }
    
  }
}
</script>



<style lang="scss" scoped>

  button {
    margin-top: 1rem;
  }
  h3 {
    margin-bottom: 2rem;
  }
  .counter-wrapper {
    height: 400px;
    width: 100%;
    position: relative;
    .counter-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      text-align: center;
      font-size: 5rem;
      font-weight: bold;
      color: skyblue;
    }
  }

</style>



